<template>
  <el-dialog
      title="修改密码"
      :visible.sync="show"
      width="600px"
    >
      <el-form
        :model="pwdInfo"
        ref="pwdInfo"
        :rules="rules"
        v-if="show"
        label-width="80px"
      >
        <el-form-item
          label="旧密码"
          prop="oldPassword"
        >
          <el-input
            v-model="pwdInfo.oldPassword"
            type="password"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPassword"
        >
          <el-input
            v-model="pwdInfo.newPassword"
            type="password"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="二次确认"
          prop="repeat_pwd"
        >
          <el-input
            v-model="pwdInfo.repeat_pwd"
            type="password"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>

      <template slot="footer">
        <el-button
          type="info"
          plain
          size="small"
          @click="$emit('update:visible',false)"
        >取消</el-button>
        <el-button
          type="primary"
          @click.native="confirm"
          size="small"
        >确 定</el-button>
      </template>
    </el-dialog>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    let validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.pwdInfo.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      pwdInfo: {
        oldPassword: "",
        newPassword: "",
        repeat_pwd: ""
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9]{1,12}$/,
            message: "长度1-12位,英文字母+数字"
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) =>
              value === this.pwdInfo.oldPassword
                ? callback(new Error("新密码和旧密码相同!"))
                : callback()
          }
        ],
        repeat_pwd: [{ validator: validatePass2, trigger: "blur" }]
      }
    }
  },
  computed: {
    ...mapState(["USER"]),
    show:{
      get(){
        return this.visible
      },
      set(val){
        this.$emit('update:visible',val);
      }
    }
  },
  watch: {
    show(val) {
      if (val === true) {
        Object.keys(this.pwdInfo).forEach(key => {
          this.pwdInfo[key] = "";
        });
      }
    }
  },
  methods:{
    ...mapMutations(["COMMIT_USER",'COMMIT_ADDRESS']),
    ...mapActions(["DISPATCH_CLEARCHACE"]),
    async confirm() {
      try {
        await this.$refs.pwdInfo.validate();
        const { oldPassword, newPassword } = this.pwdInfo;
        await this.$API.updatePassword({
          newPassword: newPassword,
          password: oldPassword
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess',newPassword);
      } catch (error) {
        console.error(error);
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确的字段",
          type: "error"
        });
      }
    },
  }
}
</script>
